import React, {
  useCallback,
  useMemo,
  useState,
  useImperativeHandle,
} from 'react';
import styled from 'styled-components';
import { FeedbackQuestionHandler, FeedbackSectionInfo } from '../utils';
import { FeedbackQuestionsById } from '../api';
import SectionIndicators from '../../../ReportBuilder/Components/SectionIndicators';
import { useProgram } from 'shared/providers/ProgramProvider';
import TrueImpactLoading from 'shared/components/TrueImpactLoading';
import {
  BENEFICIARY_TERM_QUESTION_ID,
  INTERMEDIARIES_QUESTION_ID,
} from '../../../ReportBuilder/Components/SectionMultiRadio';

interface IndicatorsCheckboxProps {
  questions: FeedbackQuestionsById;
}

const StyledDiv = styled.div``;

const IndicatorsCheckbox = React.forwardRef<
  FeedbackQuestionHandler,
  FeedbackSectionInfo & IndicatorsCheckboxProps
>(
  (
    {
      reportId,
      questionId,
      selectedSection,
      question,
      questions,
      answer,
      programName,
    },
    forwardRef,
  ) => {
    const {
      allSucceedIndicators: socialImpactIndicators,
      loadingIndicators,
    } = useProgram();

    const [value, setValue] = useState<string | string[] | undefined>(answer);
    const options = useMemo(
      () => question.enumResponses.map(({ response }) => response),
      [question],
    );

    const beneficiaryTerm =
      questions[BENEFICIARY_TERM_QUESTION_ID]?.answers[0]?.text;

    const intermediaries =
      questions[INTERMEDIARIES_QUESTION_ID]?.answers[0]?.text;

    const handleChange = useCallback(
      (questionId: number, value: string | string[]) => {
        setValue(value);
      },
      [setValue],
    );

    useImperativeHandle(forwardRef, () => ({
      reportId,
      questionId,
      answer: () =>
        value
          ? typeof value === 'string'
            ? value
            : JSON.stringify(value)
          : '',
      errorText: () => (value ? undefined : 'Please select one of the options'),
    }));

    if (loadingIndicators || !socialImpactIndicators) {
      return <TrueImpactLoading />;
    }

    return (
      <StyledDiv>
        <SectionIndicators
          title={selectedSection.section.label}
          subTitle={question.text}
          helpText=""
          programName={programName}
          intermediaries={intermediaries}
          beneficiaryTerm={beneficiaryTerm}
          options={socialImpactIndicators.options}
          value={answer}
          onChange={handleChange}
          questionId={question.dbId}
          allIndicators={socialImpactIndicators.restIndicators}
          error={undefined}
          guidanceText={undefined}
        />
      </StyledDiv>
    );
  },
);

export default IndicatorsCheckbox;
